"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSMyCspireComponent = void 0;
const account_service_1 = require("../services/account.service");
const sendsms_service_1 = require("../services/sendsms.service");
class CSMyCspireComponent {
    constructor(accountService, smsService) {
        this.accountService = accountService;
        this.smsService = smsService;
    }
    ngOnInit() {
        this.loader = true;
        this.smsSuccess = false;
        this.sentToAll = false;
        this.getLines(true);
    }
    getLines(cacheResponse) {
        this.showViewAll = false;
        this.showHideAll = false;
        this.loader = true;
        this.accountService.getAccountDetails(cacheResponse).subscribe((accountInfo) => {
            this.mobileNumbers = [];
            this.extraLines = [];
            this.subscriptions = accountInfo.subscription;
            if (this.secondary) {
                this.mobileNumbers.push(this.secondaryMobileNumber);
            }
            else {
                if (this.subscriptions) {
                    for (const sub of this.subscriptions) {
                        if (sub.fixedWireless) {
                            continue;
                        }
                        if (this.mobileNumbers.length >= 5) {
                            this.showViewAll = true;
                            this.extraLines.push(sub.mobileNumber);
                        }
                        else {
                            this.mobileNumbers.push(sub.mobileNumber);
                        }
                    }
                }
            }
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    sendSMS() {
        this.error = null;
        this.loader = true;
        this.linesToNotify = [];
        this.message = 'Wireless, meet effortless.  Download My C Spire, the perfect tool for managing your account. http://cspire.com/mycspire';
        const checkboxes = document.getElementsByName('mobileNumberForSMS');
        // loop over them all
        for (let i = checkboxes.length - 1; i >= 0; i--) {
            // And stick the checked ones onto an array...
            const newCheck = checkboxes[i];
            if (newCheck.checked) {
                this.linesToNotify.push(newCheck.value);
                // Hide the checkbox
                const checkboxContainer = checkboxes[i].parentNode;
                checkboxContainer.remove();
            }
        }
        if (this.linesToNotify.length > 0) {
            this.smsService.sendSMS(this.linesToNotify, this.message).subscribe((res) => {
                this.loader = false;
                this.smsSuccess = true;
            }, (err) => {
                this.error = err;
                this.loader = false;
            });
            if (this.linesToNotify.length === (document.getElementsByName('mobileNumberForSMS').length + this.linesToNotify.length)) {
                this.sentToAll = true;
            }
        }
        else {
            this.loader = false;
            this.error = { errorMessage: 'Please select at least one line!' };
        }
    }
    viewAll() {
        for (const line of this.extraLines) {
            this.mobileNumbers.push(line);
        }
        this.showViewAll = false;
        this.showHideAll = true;
    }
    hideAll() {
        while (this.mobileNumbers.length > 5) {
            this.mobileNumbers.pop();
        }
        this.showViewAll = true;
        this.showHideAll = false;
    }
}
exports.CSMyCspireComponent = CSMyCspireComponent;
//# sourceMappingURL=mycspire.component.js.map